import { render, staticRenderFns } from "./painelEstatistica.vue?vue&type=template&id=38210d3c&"
import script from "./painelEstatistica.vue?vue&type=script&lang=js&"
export * from "./painelEstatistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports